import React from "react";
import { Link, useHref } from "react-router-dom";

export default function ReportPopupLink({
  to,
  children,
  width = 1000,
  height = 680,
  windowName = "reportPopup", // same name => reuses the popup window
  style,
  className,
  showBlockedAlert = true,     // alert user if popup blocked (but DO NOT navigate)
}) {
  const href = useHref(to);

  const onClick = (e) => {
    // Keep ReportHome as-is: prevent Link from navigating
    e.preventDefault();

    // Make sure we pass an absolute URL to window.open
    const url = new URL(href, window.location.href).toString();

    // Center the popup relative to current window/monitor
    const dualScreenLeft = window.screenLeft ?? window.screenX ?? 0;
    const dualScreenTop  = window.screenTop  ?? window.screenY ?? 0;
    const viewportW = window.outerWidth || window.innerWidth;
    const viewportH = window.outerHeight || window.innerHeight;

    const left = Math.max(0, dualScreenLeft + (viewportW - width) / 2);
    const top  = Math.max(0, dualScreenTop  + (viewportH - height) / 2);

    const features = [
      "popup=yes",
      `width=${Math.round(width)}`,
      `height=${Math.round(height)}`,
      `left=${Math.round(left)}`,
      `top=${Math.round(top)}`,
      "resizable=yes",
      "scrollbars=yes",
      // `noopener`/`noreferrer` hints aren't consistently honored in features,
      // so we also null out `opener` explicitly below.
    ].join(",");

    const popup = window.open(url, windowName, features);

    if (!popup) {
      // Popup blocked — keep the current tab on ReportHome and optionally notify
      if (showBlockedAlert) {
        window.alert("Popup was blocked. Please allow popups for this site to view the report.");
      }
      return;
    }

    // Security hardening: prevent the popup from accessing the opener
    try { popup.opener = null; } catch {}
    popup.focus();
    // Do NOT navigate in the current window
  };

  return (
    <Link
      to={to}
      onClick={onClick}
      style={{ cursor: "pointer", ...style }}
      className={className}
    >
      {children}
    </Link>
  );
}